"use strict";
var ReactRef = require("./ReactRef");
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}
var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {string} rootID DOM ID of the root node.
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function(internalInstance, rootID, transaction, context) {
    var markup = internalInstance.mountComponent(rootID, transaction, context);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    return markup;
  },
  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function(internalInstance) {
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent();
  },
  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function(internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;
    if (nextElement === prevElement && context === internalInstance._context) {
      return;
    }
    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }
    internalInstance.receiveComponent(nextElement, transaction, context);
    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
  },
  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function(internalInstance, transaction) {
    internalInstance.performUpdateIfNecessary(transaction);
  }
};
module.exports = ReactReconciler;
